// Auto-generated by build-comment-action-sprite.js
export const SPRITE_VERSION = "3e38d85e";
